import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  IApiResponse,
  IProductBalanceDto,
  IProductDetailsDto,
  IProductDto,
  IProductItemsDto,
  IProductOrderDto,
  IProductReviewDto,
} from '../models';
import { KeyValue } from '@angular/common';

@Injectable()
export class GiftCardService extends ApiService {
  private readonly _currentProudctSubject =
    new BehaviorSubject<IProductReviewDto>(null);
  // public currentProductDetails: Observable<IProductReviewDto> =
  //   this._currentProudctSubject.asObservable();

  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public setCurrentProduct(model: IProductReviewDto): void {
    this._currentProudctSubject.next(model);
  }

  public get currentProduct(): IProductReviewDto {
    return this._currentProudctSubject.value;
  }

  public getProductList(id: number): Observable<IProductDto[]> {
    return this.get(`gift/${id}`);
  }

  public getProductDetails(id: number): Observable<IProductDetailsDto> {
    return this.get(`gift/details/${id}`);
  }

  public getProductItems(id: number): Observable<IProductItemsDto> {
    return this.get(`gift/items/${id}`);
  }

  public buyProduct(
    model: IProductReviewDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`gift`, model);
  }

  public getProductOrder(id: string): Observable<IProductOrderDto> {
    return this.get(`gift/${id}`);
  }

  public getProductBalance(
    model: IProductBalanceDto
  ): Observable<IApiResponse<IProductBalanceDto>> {
    return this.post(`gift/balance`, model);
  }

  public sendGiftCard(
    model: KeyValue<string, number>
  ): Observable<IApiResponse<boolean>> {
    return this.post(`gift/giftcard`, model);
  }
}
